import { routerMiddleware } from 'connected-react-router';
import { middlewares as segmentMiddleware } from '@saucelabs/sl-util-segmentio';
import { applyMiddleware, compose, createStore } from 'redux';
import { errorPageMiddleware } from '@saucelabs/sl-container-error-pages';
import { createBrowserHistory } from 'history';
import { sentryCrashReporter, historyRedirectMiddleware } from '@saucelabs/sl-util-redux';
import thunk from 'redux-thunk';
import dynostore, { dynamicReducers } from '@redux-dynostore/core';

import createRootReducer from './createReducer';
import deepStateHandler from './utils';

export const browserHistory = createBrowserHistory({ basename: '' });
const { pageMiddleware } = segmentMiddleware;

const middlewares = [
  applyMiddleware(
    sentryCrashReporter,
    thunk,
    historyRedirectMiddleware,
    errorPageMiddleware(),
    pageMiddleware,
  ),
  applyMiddleware(routerMiddleware(browserHistory)),
];

if (window.__REDUX_DEVTOOLS_EXTENSION__) { // eslint-disable-line
  middlewares.push(window.__REDUX_DEVTOOLS_EXTENSION__()); // eslint-disable-line
}

const store = createStore(
  createRootReducer(browserHistory),
  {},
  compose(
    dynostore(
      dynamicReducers({ stateHandler: deepStateHandler }),
    ),
    ...middlewares,
  ),
);

if (module.hot) {
  module.hot.accept('./createReducer', () => {
    // eslint-disable-next-line global-require
    const nextRootReducer = require('./createReducer');

    store.replaceReducer(nextRootReducer);
  });
}

export default store;
